<template>
  <div class="image-picker">
    <div v-for="image in images" class="image-container" v-bind:key="image.key">
      <router-link :to="'images/' + image.key">
        <app-image :src="image.url_small" :grid_item="true"/>
      </router-link>
    </div>
  </div>
</template>

<script>
import AppImage from './AppImage'
export default {
  components: {AppImage},
  props: ['images'],
  data: () => {
    return {}
  },
}
</script>
